// extracted by mini-css-extract-plugin
export default {"container":"style_container__DxHNS","message":"style_message__2XnI+"};